import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

export function ViewReveiwText({ count, onClick }: { count: string; onClick?: () => void }) {
  return <Wrapper className={Typography.CAPTION_12_REGULAR} onClick={onClick}>{`${count}개의 리뷰 보기`}</Wrapper>;
}

const Wrapper = styled.span`
  margin: 0 0 0 6px;
  padding: 11px 0;
  color: ${vars.v3Color.gray700};
  text-decoration: underline;
  cursor: pointer;
`;
